import { useMemo } from "react";
import { useScreen } from "../store/session/hooks";
import { useSettings } from "./settings";

const DEFAULT_PARAMS = { rows: 3, columns: 4 } as const;

export const DEFAULT_SCREEN_INDEX = 0;

export interface ScreenParams {
  index: number;
  name?: string;
  rows: number;
  columns: number;
  panelWidth?: string;
}

export const useScreenParams = (): ScreenParams => {
  const [settings] = useSettings();
  const screen = useScreen();
  const params = useMemo(() => {
    const index = screen?.index === undefined ? DEFAULT_SCREEN_INDEX : screen.index;
    const defaultSettingsParams =
      settings?.carousel?.screens?.find((p) => {
        return p.index === undefined;
      }) ?? {};
    const settingsParams =
      settings?.carousel?.screens?.find((p) => {
        return p.index === index;
      }) ?? {};
    return Object.assign({}, DEFAULT_PARAMS, defaultSettingsParams, settingsParams, { index, name: screen?.name });
  }, [settings, screen]);

  return params;
};
